var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_233_693",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_233_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7831 28.6369L25.8908 24.7468C29.0551 20.9541 28.5595 15.2938 24.7778 12.1096C20.9851 8.91652 15.3026 9.40333 12.1096 13.1961C8.91652 16.9888 9.40334 22.6712 13.1961 25.8643C16.5418 28.6812 21.3922 28.69 24.7468 25.8908L28.6369 29.7831C28.7918 29.9292 28.991 30 29.1879 30C29.4048 30 29.6216 29.9137 29.7809 29.7433C30.0686 29.4335 30.0686 28.9489 29.7809 28.6391L29.7831 28.6369ZM26.3577 19.0069C26.3577 23.0607 23.0585 26.36 19.0046 26.36C14.9552 26.3555 11.656 23.0585 11.6515 19.0069C11.6515 14.953 14.9508 11.6537 19.0046 11.6537C23.0585 11.6537 26.3577 14.953 26.3577 19.0069Z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlack);
export default __webpack_public_path__ + "static/media/icon_search_black.ae4c0b75d50edab967caf96bdeee5bea.svg";
export { ForwardRef as ReactComponent };